import { MRT_ColumnDef } from "material-react-table"
import { Box, SxProps } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"

const CELLWIDTH = 150

export const headerStyles: React.CSSProperties = {
  backgroundColor: "#4A7FF2",
  height: "48px",
  paddingLeft: "20px",
  color: "#fff",
  fontWeight: "bold",
  border: "0.5px solid #E4E4E4",
  boxShadow: " #00000022 1.95px  0px 2.6px",
  justifyContent: "center",
}

const disabledCellStyles: React.CSSProperties = {
  backgroundColor: colors.grey50,
  height: "48px",
  justifyContent: "center",
  border: "0.5px solid #E4E4E4",
  boxShadow: " #00000022 1.95px  0px 2.6px",
}

export const footerCellStyles: React.CSSProperties = {
  ...disabledCellStyles,
  height: "84px",
  justifyContent: "center",
  backgroundColor: colors.darkBlue,
  color: "#fff",
  padding: 0,
}

export const topFooterCellStyles: React.CSSProperties = {
  borderBottom: "1px solid #fff",
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}
export const bottomFooterCellStyles: React.CSSProperties = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}
export const disableColHeadStyles: SxProps = {
  color: "#fff",
  fontWeight: "bold",
  backgroundColor: colors.primaryBlue,
  borderRight: "0.5px solid  #fff",
  borderLeft: "0.5px solid  #fff",
  pt: 0,
  borderTopWidth: 0,
  mt: -5,
  justifyContent: "center",
}

export const disableColBodyStyles: SxProps = {
  borderRight: "0.5px solid  #E4E4E4",
  borderLeft: "0.5px solid  #E4E4E4",
  pt: 0,
  backgroundColor: colors.grey50,
  borderTopWidth: 0,
  borderBottomWidth: 0,
}

export const stringCols: string[] = [
  "line_item",
  "-budget_Amount",
  "-budget_Percent",
  "annual_amount",
  "total_budget_Percent",
]

export const PNLConfig: MRT_ColumnDef<any>[] = [
  {
    header: "",
    id: "table-head",
    columns: [
      {
        header: "Line items",
        accessorKey: "line_item",
        enableEditing: false,
        size: 280,
        muiTableHeadCellProps: {
          sx: {
            color: "#fff",
            fontWeight: "bold",
            backgroundColor: colors.primaryBlue,
            border: "0px",
            pt: 0,
            mt: -6,
            justifyContent: "center",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            ...headerStyles,
            backgroundColor: "#fff",
            color: "#000",
            justifyContent: "flex-start",
          },
        },
        muiTableFooterCellProps: {
          sx: {
            justifyContent: "center",
            backgroundColor: colors.darkBlue,
            color: "#fff",
            border: 0,
            p: 0,
            m: 0,
          },
        },
        Footer: () => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                borderRight: "1px solid #fff",
              }}
            >
              <Box
                sx={{
                  ...topFooterCellStyles,
                  justifyContent: "flex-start",
                  pl: "20px",
                }}
              >
                Total Expenses
              </Box>
              <Box
                sx={{
                  ...bottomFooterCellStyles,
                  justifyContent: "flex-start",
                  pl: "20px",
                }}
              >
                EBITDA
              </Box>
            </Box>
          )
        },
        Cell: ({ renderedCellValue }: any) => renderedCellValue || "",
      },
    ],
  },
  {
    header: "Previous stats",
    columns: [
      {
        header: "$",
        id: "-budget_amount",
        accessorKey: "-budget_amount",
        size: CELLWIDTH,
        enableEditing: true, //! put condition here
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: ({ row }: any) => {
          return {
            sx: {
              // ...disabledCellStyles,
              backgroundColor: 1 ? colors.primaryWhite : colors.grey50, //! put condition here
              height: "48px",
              justifyContent: "center",
              border: "0.5px solid #E4E4E4",
              boxShadow: " #00000022 1.95px  0px 2.6px",
              fontWeight: row.index ? "regular" : "bold",
            },
          }
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue }: any) =>
          `$ ${parseInt(renderedCellValue || "0").toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}`,
      },
      {
        header: "%",
        id: "-budget_percent",
        accessorKey: "-budget_percent",
        size: CELLWIDTH,
        enableEditing: true, //! put condition here
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: {
          sx: {
            // ...disabledCellStyles,
            backgroundColor: 1 ? colors.primaryWhite : colors.grey50, //! put condition here
            height: "48px",
            justifyContent: "center",
            border: "0.5px solid #E4E4E4",
            boxShadow: " #00000022 1.95px  0px 2.6px",
          },
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue, row }: any) =>
          row.index > 0
            ? `${parseFloat(renderedCellValue || "0").toFixed(1)} %`
            : null,
      },
      {
        header: "Annualized",
        id: "-annual_amount",
        accessorKey: "-annual_amount",
        size: CELLWIDTH,
        enableEditing: true, //! put condition here
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: ({ row }: any) => {
          return {
            sx: {
              // ...disabledCellStyles,
              backgroundColor: 1 ? colors.primaryWhite : colors.grey50, //! put condition here
              height: "48px",
              justifyContent: "center",
              border: "0.5px solid #E4E4E4",
              boxShadow: " #00000022 1.95px  0px 2.6px",
              fontWeight: row.index ? "regular" : "bold",
            },
          }
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue }: any) =>
          `$ ${parseInt(renderedCellValue || "0").toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}`,
      },
    ],
  },
  {
    header: "<Y>",
    id: "curr-agg",
    columns: [
      {
        header: "$",
        id: "-total_current",
        accessorKey: "-total_current",
        enableEditing: true, //! put condition here
        size: CELLWIDTH,
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: ({ row }: any) => {
          return {
            sx: {
              // ...disabledCellStyles,
              backgroundColor: 1 ? colors.primaryWhite : colors.grey50, //! put condition here
              height: "48px",
              justifyContent: "center",
              border: "0.5px solid #E4E4E4",
              boxShadow: " #00000022 1.95px  0px 2.6px",
              fontWeight: row.index ? "regular" : "bold",
            },
          }
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue }: any) =>
          `$ ${parseInt(renderedCellValue as string).toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}` || "$ 0",
      },
      {
        header: "%",
        id: "-total_current_percent",
        accessorKey: "-total_current_percent",
        size: CELLWIDTH,
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: ({ row }: any) => {
          return {
            sx: {
              // ...disabledCellStyles,
              backgroundColor: 1 ? colors.primaryWhite : colors.grey50, //! put condition here
              height: "48px",
              justifyContent: "center",
              border: "0.5px solid #E4E4E4",
              boxShadow: " #00000022 1.95px  0px 2.6px",
            },
          }
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        enableEditing: (row) => row?.original?.line_item !== "REVENUE",
        Cell: ({ renderedCellValue, row }: any) =>
          row.index > 0
            ? `${parseFloat(renderedCellValue || "0").toFixed(1)} %`
            : null,
      },
    ],
  },
]
export const PNLConfigDisabled: MRT_ColumnDef<any>[] = [
  {
    header: "",
    id: "table-head",
    columns: [
      {
        header: "Line items",
        accessorKey: "line_item",
        enableEditing: false,
        size: 280,
        muiTableHeadCellProps: {
          sx: {
            color: "#fff",
            fontWeight: "bold",
            backgroundColor: colors.primaryBlue,
            border: "0px",
            pt: 0,
            mt: -6,
            justifyContent: "center",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            ...headerStyles,
            backgroundColor: "#fff",
            color: "#000",
            justifyContent: "flex-start",
          },
        },
        muiTableFooterCellProps: {
          sx: {
            justifyContent: "center",
            backgroundColor: colors.darkBlue,
            color: "#fff",
            border: 0,
            p: 0,
            m: 0,
          },
        },
        Footer: () => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                borderRight: "1px solid #fff",
              }}
            >
              <Box
                sx={{
                  ...topFooterCellStyles,
                  justifyContent: "flex-start",
                  pl: "20px",
                }}
              >
                Total Expenses
              </Box>
              <Box
                sx={{
                  ...bottomFooterCellStyles,
                  justifyContent: "flex-start",
                  pl: "20px",
                }}
              >
                EBITDA
              </Box>
            </Box>
          )
        },
        Cell: ({ renderedCellValue }: any) => renderedCellValue || "",
      },
    ],
  },
  {
    header: "Previous stats",
    columns: [
      {
        header: "$",
        id: "-budget_amount",
        accessorKey: "-budget_amount",
        size: CELLWIDTH,
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: ({ row }: any) => {
          return {
            sx: {
              ...disabledCellStyles,
              fontWeight: row.index ? "regular" : "bold",
            },
          }
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue }: any) =>
          `$ ${parseInt(renderedCellValue || "0").toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}`,
      },
      {
        header: "%",
        id: "-budget_percent",
        accessorKey: "-budget_percent",
        size: CELLWIDTH,
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: {
          sx: {
            ...disabledCellStyles,
            boxShadow: " #00000022 1.95px  0px 2.6px",
          },
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue, row }: any) =>
          row.index > 0
            ? `${parseFloat(renderedCellValue || "0").toFixed(1)} %`
            : null,
      },
      {
        header: "Annualized",
        id: "-annual_amount",
        accessorKey: "-annual_amount",
        size: CELLWIDTH,
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: ({ row }: any) => {
          return {
            sx: {
              ...disabledCellStyles,
              fontWeight: row.index ? "regular" : "bold",
            },
          }
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue }: any) =>
          `$ ${parseInt(renderedCellValue || "0").toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}`,
      },
    ],
  },
  {
    header: "<Y>",
    id: "curr-agg",
    columns: [
      {
        header: "$",
        id: "-total_current",
        accessorKey: "-total_current",
        enableEditing: false,
        size: CELLWIDTH,
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: ({ row }: any) => {
          return {
            sx: {
              ...disabledCellStyles,
              fontWeight: row.index ? "regular" : "bold",
            },
          }
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue }: any) =>
          `$ ${parseInt(renderedCellValue as string).toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}` || "$ 0",
      },
      {
        header: "%",
        id: "-total_current_percent",
        accessorKey: "-total_current_percent",
        enableEditing: false,
        size: CELLWIDTH,
        muiTableHeadCellProps: {
          sx: { ...headerStyles },
        },
        muiTableBodyCellProps: {
          sx: {
            ...disabledCellStyles,
          },
        },
        muiTableFooterCellProps: {
          sx: { ...footerCellStyles },
        },
        Cell: ({ renderedCellValue, row }: any) =>
          row.index > 0
            ? `${parseFloat(renderedCellValue || "0").toFixed(1)} %`
            : null,
      },
    ],
  },
]
